
import React from "react";
import {
    Box,
    Typography,
    Grid,
    Container,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    CardContent,
    styled,
    Card,
    Divider,
} from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import app from "../assets/app.png";
import logo from "../assets/mission.png";
import Popup from "./Popup";
import { useNavigate } from "react-router-dom";
import exams from "../assets/exams.png";
import sslc from "../assets/class.png";
import pg from "../assets/pg.png";
import ug from "../assets/ug.png";
import puc from "../assets/puc.png";
import engineering from "../assets/engineering.png";
import telephone from "../assets/telephone.png";
import email from "../assets/email.png";
import location from "../assets/location.png";
import { motion } from "framer-motion";

const sections = [
    {
        title: "SSLC",
        description:
            "For anyone tackling SSLC, grab full guides, clear lessons, and solid practice kits. Access all the content you need to prepare effectively and excel in your exams.",
        image: sslc,
    },
    {
        title: "PUC",
        description:
            "You’ll find every vital note, useful resource, and exam guide contributed by PUC students. Access everything you need to excel in your exams, tailored to your curriculum and subjects.",
        image: puc,
    },
    {
        title: "Undergraduate",
        description:
            "Get detailed lecture notes, practice sheets, and extra resources for any college course you take. Get all the tools you need to ace your tests and raise your grades.",
        image: ug,
    },
    {
        title: "Postgraduate",
        description:
            "Access comprehensive Educational notes, reference materials, and test resources designed to meet all your PG academic needs.",
        image: pg,
    },
    {
        title: "Engineering",
        description:
            "Your portal gives you quick access to lecture slides, flashcards and rubrics that match every class you take.",
        image: engineering,
    },
    {
        title: "Exam Notes & Syllabus",
        description:
            "Comprehensive exam summaries and syllabus packs are available, built around the individual needs of every student. Get all your study guides, review them well, and boost your exam scores.",
        image: exams,
    },
];
const StyledCard = styled(Card)({
    height: "100%",
    borderRadius: 16,
    boxShadow: "0px 10px 20px rgba(0,0,0,0.15)",
    transition: "0.3s",
    "&:hover": {
        transform: "translateY(-8px)",
        boxShadow: "0px 18px 28px rgba(0,0,0,0.3)",
    },
});

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, ease: "easeOut" },
    },
};

const LandingPage = () => {
    const navigate = useNavigate();
    return (
        <>
            <Header />
            <Box
                sx={{
                    minHeight: "50vh",
                    background:
                        "linear-gradient(135deg, #0D2A54 0%, #1A4B83 50%, #2B6BA5 100%)",
                    display: "flex",
                    alignItems: "center",
                    // position: "relative",

                }}
            >
                <Container
                    sx={{ position: "relative", zIndex: 1, textAlign: "center" }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            color: "white",
                            fontWeight: 800,
                            fontSize: { xs: "2.2rem", md: "3rem", lg: "4rem" },
                            mb: 3,
                            textShadow: "0 4px 8px rgba(0,0,0,0.3)",
                        }}
                    >
                        Empowering Student Futures
                    </Typography>
                    <Typography
                        sx={{
                            color: "white",
                            maxWidth: 800,
                            mx: "auto",
                            mb: 5,
                            fontWeight: 300,
                            lineHeight: 1.6,
                            fontSize: { xs: "1rem", md: "1.2rem" },
                        }}
                    >
                        GetMyRank is a non-profit educational initiative
                        <span
                            style={{
                                color: "#FFD700",
                                fontWeight: 900,
                                marginLeft: "6px",
                                marginRight: "6px",
                                // textDecoration: "underline",
                                // textUnderlineOffset: "4px",
                            }}
                        >
                            (NGO)
                        </span>
                        providing 100% FREE study materials from SSLC to Master’s level.
                    </Typography>


                    <Button
                        variant="contained"
                        size="large"
                        component="a"
                        href="https://play.google.com/store/apps/details?id=com.getmyrank&hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            px: 5,
                            py: 1.8,
                            fontSize: "1rem",
                            fontWeight: 700,
                            borderRadius: 50,
                            bgcolor: "white",
                            color: "#1A4B83",
                            boxShadow: "0 8px 32px rgba(255,255,255,0.3)",
                            "&:hover": {
                                bgcolor: "#f8fafc",
                                transform: "translateY(-2px)",
                                boxShadow: "0 12px 40px rgba(255,255,255,0.4)",
                            },
                        }}
                    >
                        Download GetMyRank
                    </Button>
                </Container>
            </Box>

            <Grid
                container
                spacing={4}
                sx={{
                    p: { xs: 2, md: 10 },
                    background: "linear-gradient(60deg,#F9FAFF, #F3F4FF)",
                }}
            >
                <Grid size={{ xs: 12, md: 12 }}>
                    <Box>

                        <Typography
                            sx={{
                                fontSize: { xs: 25, md: 40 },
                                color: '#1A4B83',
                                fontWeight: "bold",
                                textAlign: "center",
                                mx: 'auto',
                                mb: 3,
                                borderBottom: "3px solid #1A4B83",

                                width: "fit-content",
                            }}
                        >
                            Welcome to GetMyRank
                        </Typography>

                        <Typography
                            sx={{
                                textAlign: "center",
                                mt: 1,
                                fontSize: { xs: 15, md: 19 },
                            }}
                        >
                            Your one-stop platform for SSLC, PUC, UG, and PG notes, study
                            materials, and exam resources.
                        </Typography>
                    </Box>
                </Grid>

                {sections.map((s, i) => (
                    <Grid size={{ xs: 12, md: 4, sm: 6 }} key={i}>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: 0.5,
                                delay: i * 0.15,
                            }}
                            style={{ height: "100%" }}
                        >
                            <StyledCard
                                sx={{
                                    borderLeft: "5px solid #1A4B83",
                                    borderRight: "5px solid #1A4B83",
                                    height: "100%",
                                }}
                            >
                                <CardContent sx={{ textAlign: "center" }}>
                                    <Box component="img" src={s.image} sx={{ width: 90, mb: 2 }} />

                                    <Typography variant="h5" fontWeight="bold">
                                        {s.title}
                                    </Typography>

                                    <Typography mt={1}>{s.description}</Typography>

                                    <Button
                                        onClick={() => navigate("/categories")}
                                        variant="contained"
                                        sx={{
                                            mt: 2,
                                            px: 5,
                                            borderRadius: 8,
                                            background:
                                                "linear-gradient(60deg,#0D2A54, #1A4B83, #2B6BA5)",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Read More
                                    </Button>
                                </CardContent>
                            </StyledCard>
                        </motion.div>
                    </Grid>
                ))}

            </Grid>

            <Grid container spacing={6} alignItems="center" sx={{ p: { xs: 2, md: 10 } }}>
                <Grid size={{ xs: 12, md: 6, sm: 12 }}>
                    <motion.div
                        initial={{ opacity: 0, x: -80 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                    >
                        <Box
                            component="img"
                            src={logo}
                            alt="GetMyRank Mission"
                            sx={{
                                width: "100%",
                                height: { xs: 200, md: "auto" },
                                borderRadius: 10,
                                boxShadow: "0 20px 60px rgba(13,42,84,0.15)",
                                objectFit: "cover",
                            }}
                        />
                    </motion.div>
                </Grid>
                <Grid size={{ xs: 12, md: 6, sm: 12 }}>
                    <motion.div
                        initial={{ opacity: 0, x: 80 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                    >
                        <Typography

                            sx={{
                                color: "#1A4B83", fontWeight: 700, mb: 2, fontSize: { xs: 25, md: 35 }, borderBottom: "4px solid #1A4B83",

                                width: "fit-content",
                                // mx: "auto",

                            }}
                        >
                            Our Mission
                        </Typography>
                        <Typography
                            sx={{
                                color: "#475569",
                                mb: 4,
                                lineHeight: 2.0,

                                textAlign: 'justify',
                                fontSize: 18
                            }}
                        >
                            GetMyRank is a non-profit educational organization committed to
                            bridging the education gap by delivering high-quality learning resources at no
                            cost. We provide 100% FREE study materials from SSLC to Master’s level, along
                            with career guidance and academic support. Through college outreach programs,
                            counseling initiatives, and our digital learning platform, we strive to ensure
                            equal educational opportunities for every student, regardless of background or
                            financial status.

                        </Typography>
                    </motion.div>
                </Grid>
            </Grid>


            <Box
                sx={{
                    py: { xs: 8, md: 12 },
                    background: "linear-gradient(135deg, #f0f4ff 0%, #e0ebff 100%)",
                }}
            >
                <Container maxWidth="lg">
                    <Grid container spacing={6} >
                        {/* App Screenshot */}
                        <Grid size={{ xs: 12, md: 4, sm: 6 }}>
                            <Box
                                component="img"
                                src={app}
                                alt="GetMyRank App"
                                sx={{
                                    width: "100%",
                                    // maxWidth: 350,
                                    height: 700,
                                    mx: "auto",
                                    borderRadius: 3,
                                    // boxShadow: "0 20px 60px rgba(26,75,131,0.15)",
                                }}
                            />
                        </Grid>

                        {/* App Features */}
                        <Grid size={{ xs: 12, md: 8, sm: 12 }} sx={{ mt: { xs: 0, md: 8 } }}>
                            <Typography
                                variant="h3"
                                sx={{
                                    color: "#1A4B83",
                                    fontWeight: 900,
                                    textAlign: "center",
                                    mb: 5,
                                    mt: { xs: 0, md: 5 },
                                    fontSize: { xs: "2rem", md: "2.8rem" },
                                    borderBottom: "4px solid #1A4B83",

                                    width: "fit-content",
                                }}
                            >
                                All-in-One Learning App
                            </Typography>
                            <List>

                                {/* 1 */}
                                <ListItem sx={{ py: 1 }}>
                                    <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40, fontSize: 24 }}>
                                        📚
                                    </ListItemIcon>

                                    <ListItemText
                                        primary="SSLC to Master's Notes & Syllabus"
                                        secondary="Access all subjects, chapter-wise notes, and complete syllabus in one app."
                                        primaryTypographyProps={{
                                            fontSize: { xs: "16px", md: "20px" },
                                            fontWeight: 600,
                                            color: "#1A4B83",
                                        }}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13px", md: "16px" },
                                            color: "#475569",
                                        }}
                                    />
                                </ListItem>

                                {/* 2 */}
                                <ListItem sx={{ py: 1 }}>
                                    <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40, fontSize: 24 }}>
                                        📝
                                    </ListItemIcon>

                                    <ListItemText
                                        primary="Practice Papers & Previous Year Questions"
                                        secondary="Solve questions, test yourself, and track progress easily."
                                        primaryTypographyProps={{
                                            fontSize: { xs: "16px", md: "20px" },
                                            fontWeight: 600,
                                            color: "#1A4B83",
                                        }}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13px", md: "16px" },
                                            color: "#475569",
                                        }}
                                    />
                                </ListItem>

                                {/* 3 */}
                                <ListItem sx={{ py: 1 }}>
                                    <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40, fontSize: 24 }}>
                                        🎓
                                    </ListItemIcon>

                                    <ListItemText
                                        primary="Learning Solutions & Career Guidance"
                                        secondary="Plan your studies, get recommendations, and career counseling."
                                        primaryTypographyProps={{
                                            fontSize: { xs: "16px", md: "20px" },
                                            fontWeight: 600,
                                            color: "#1A4B83",
                                        }}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13px", md: "16px" },
                                            color: "#475569",
                                        }}
                                    />
                                </ListItem>

                                {/* 4 */}
                                <ListItem sx={{ py: 1 }}>
                                    <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40, fontSize: 24 }}>
                                        💯
                                    </ListItemIcon>

                                    <ListItemText
                                        primary="100% Free Access"
                                        secondary="All study materials and guidance are completely free forever."
                                        primaryTypographyProps={{
                                            fontSize: { xs: "16px", md: "20px" },
                                            fontWeight: 600,
                                            color: "#1A4B83",
                                        }}
                                        secondaryTypographyProps={{
                                            fontSize: { xs: "13px", md: "16px" },
                                            color: "#475569",
                                        }}
                                    />
                                </ListItem>

                            </List>


                            <Box sx={{ mt: 4, ml: { xs: 3, md: 5 } }}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    component="a"
                                    href="https://play.google.com/store/apps/details?id=com.getmyrank&hl=en"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        px: 6,
                                        py: 1.8,
                                        fontSize: { xs: 15, md: 20 },
                                        fontWeight: 700,
                                        borderRadius: 50,
                                        bgcolor: "#1A4B83",
                                        color: "white",
                                        boxShadow: "0 8px 30px rgba(26,75,131,0.3)",
                                        "&:hover": {
                                            bgcolor: "#2B6BA5",
                                            transform: "translateY(-2px)",
                                            boxShadow: "0 12px 40px rgba(26,75,131,0.4)",
                                        },
                                    }}
                                >
                                    Download the App
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>


            <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }}>
                <Typography
                    variant="h3"
                    sx={{
                        color: "#1A4B83",
                        fontWeight: 700,
                        textAlign: "center",
                        mb: 6,
                        fontSize: { xs: "2rem", md: "2.8rem" },
                        borderBottom: "4px solid #1A4B83",
                        mx: 'auto',
                        width: "fit-content",
                    }}
                >
                    How to Use the App
                </Typography>

                <Grid container spacing={6}>
                    {[
                        {
                            step: "1",
                            title: "Download & Install",
                            desc: "Get the app from Play Store and install it on your device.",
                        },
                        {
                            step: "2",
                            title: "Sign Up",
                            desc: "Create your free account to access all features.",
                        },
                        {
                            step: "3",
                            title: "Explore Materials",
                            desc: "Access SSLC to Master's notes, syllabus, and papers.",
                        },
                        {
                            step: "4",
                            title: "Track Progress",
                            desc: "Solve questions and monitor your performance.",
                        },
                    ].map((item, index, arr) => (
                        <Grid key={item.step} size={{ xs: 12, md: 3, md: 3 }}>
                            <Box
                                sx={{
                                    position: "relative",
                                    textAlign: "center",
                                    p: 4,
                                    borderRadius: 3,
                                    bgcolor: "#f0f4ff",
                                    boxShadow: "1 10px 30px rgba(43,107,165,0.1)",
                                    height: 150,
                                    transition: "0.3s",

                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        right: "-60px",
                                        width: "60px",
                                        height: "4px",
                                        bgcolor: "#1A4B83",
                                        display: {
                                            xs: "none",
                                            md: index !== arr.length - 1 ? "block" : "none",
                                        },
                                    },

                                    "&:hover": {
                                        bgcolor: "#1A4B83",
                                        color: "#fff",

                                        "& .MuiTypography-root": {
                                            color: "#fff",
                                        },
                                    },
                                }}
                            >

                                <Typography
                                    variant="h4"
                                    sx={{ fontWeight: 700, mb: 1 }}
                                >
                                    {item.step}
                                </Typography>

                                <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>
                                    {item.title}
                                </Typography>

                                <Typography sx={{ fontSize: "1rem" }}>
                                    {item.desc}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* Benefits Section */}
            <Box
                sx={{
                    py: { xs: 8, md: 12 },
                    background: "linear-gradient(135deg, #f0f4ff 0%, #e0ebff 100%)",
                    color: "white",
                }}
            >
                <Container maxWidth="lg">
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 700,
                            textAlign: "center",
                            color: "#1A4B83",
                            mb: 6,
                            fontSize: { xs: "2rem", md: "2.8rem" },
                            borderBottom: "4px solid #1A4B83",
                            mx: 'auto',
                            width: "fit-content",
                        }}
                    >
                        Benefits of GetMyRank
                    </Typography>
                    <Grid container spacing={6}>
                        {[
                            "Access all syllabus and notes from SSLC to Master's",
                            "Practice papers and previous year questions",
                            "Career guidance and learning solutions",
                            "Completely free forever, no hidden costs",
                        ].map((benefit, index) => (
                            <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                <Box
                                    sx={{
                                        textAlign: "center",
                                        p: 2,
                                        borderRadius: 3,
                                        bgcolor: "#2B6BA5",
                                    }}
                                >
                                    <Typography variant="h5" sx={{ fontWeight: 900, mb: 1, color: "#fff", }}>
                                        {index + 1}
                                    </Typography>
                                    <Typography sx={{ fontSize: "1rem", color: "#fff", }}>{benefit}</Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
            <Grid
                container
                sx={{
                    bgcolor: "#f5f9ff",
                    p: 5,
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: { xs: "column", md: "row" },
                    borderRadius: 3,
                    boxShadow: "0 8px 25px rgba(26,75,131,0.08)",
                }}
            >
                {/* ================= CALL US ================= */}
                <Grid
                    size={{ xs: 12, md: 3.5, sm: 5 }}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mb: { xs: 3, md: 0 },
                        transition: "all 0.3s ease",
                        "&:hover": {
                            transform: "translateY(-6px)",
                        },
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={telephone}
                            alt="telephone"
                            style={{ width: 70, height: 70 }}
                        />

                        <Box sx={{ ml: 2, textAlign: "left" }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "15px", md: "20px" },
                                    fontWeight: 700,
                                    color: "#1A4B83",
                                }}
                            >
                                Call Us
                            </Typography>

                            <Typography
                                component="a"
                                href="tel:+917892936369"
                                sx={{
                                    fontSize: { xs: "14px", md: "15px" },
                                    fontWeight: 600,
                                    color: "#475569",
                                    textDecoration: "none",
                                    transition: "all 0.3s ease",

                                    "&:hover": {
                                        color: "#1A4B83",
                                        textDecoration: "underline",
                                    },
                                }}
                            >
                                +91 78929 36369
                            </Typography>

                        </Box>
                    </Box>
                </Grid>

                {/* Divider */}
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        display: { xs: "none", md: "block" },
                        borderColor: "#1A4B83",
                        opacity: 0.5,
                    }}
                />

                {/* ================= EMAIL ================= */}
                <Grid

                    size={{ xs: 12, md: 4, sm: 5 }}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mb: { xs: 3, md: 0 },
                        transition: "all 0.3s ease",
                        "&:hover": {
                            transform: "translateY(-6px)",
                        },
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={email}
                            alt="email"
                            style={{ width: 65, height: 65 }}
                        />

                        <Box sx={{ ml: 2, textAlign: "left" }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "15px", md: "20px" },
                                    fontWeight: 700,
                                    color: "#1A4B83",
                                }}
                            >
                                Admission Enquiry
                            </Typography>

                            <Typography
                                component="a"
                                href="mailto:getmyrank0@gmail.com"
                                sx={{
                                    fontSize: { xs: "14px", md: "15px" },
                                    fontWeight: 900,
                                    color: "#000",
                                    textDecoration: "none",
                                    transition: "0.3s",
                                    "&:hover": { color: "#1A4B83" },
                                }}
                            >
                                getmyrank0@gmail.com
                            </Typography>
                        </Box>
                    </Box>
                </Grid>

                {/* Divider */}
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        display: { xs: "none", md: "block" },
                        borderColor: "#1A4B83",
                        opacity: 0.5,

                    }}
                />

                {/* ================= LOCATION ================= */}
                <Grid
                    size={{ xs: 12, md: 4, sm: 6 }}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "all 0.3s ease",
                        "&:hover": {
                            transform: "translateY(-6px)",
                        },
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={location}
                            alt="location"
                            style={{ width: 65, height: 65 }}
                        />

                        <Box sx={{ ml: 2, textAlign: "left" }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "15px", md: "20px" },
                                    fontWeight: 700,
                                    color: "#1A4B83",
                                }}
                            >
                                Location
                            </Typography>

                            <Typography
                                component="a"
                                href="https://www.google.com/maps?q=Bangalore,+Karnataka+560004"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    fontSize: { xs: "14px", md: "15px" },
                                    fontWeight: 900,
                                    color: "#000",
                                    textDecoration: "none",
                                    transition: "0.3s",

                                    "&:hover": { color: "#1A4B83", textDecoration: "underline", },
                                }}
                            >
                                Bangalore, Karnataka 560004
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Footer />
            <Popup />
        </>
    );
};

export default LandingPage;
